module.exports = __webpack_public_path__ + "img/1535997859.c0487535.jpg";